export default "__VITE_ASSET__pnmy6nv2__"